import React, { useEffect, useState, useRef } from "react";
import styles from "./CollapsibleSection.css";
import SectionSettings from "./SectionManager/SectionSettings";

function CollapsibleSection ({ title, children, onChangeMasterUpdate, sections }) {
	const [ collapsed, setCollapsed ] = useState(false);

	const collapsibleHeaderRef = useRef();

	useEffect(() => {
		const formSectionBadgeDescription = "Each question added to the form will need a  Label and Key. The Label will be the column header for this question on the dashboard and in your reports. The Key is the unique identifier for this question. The key cannot change once the form has been published.";

		setTimeout(() => {
			if (collapsibleHeaderRef?.current) {
				if (collapsibleHeaderRef?.current?.querySelector("._pendo-badge input")) {
					// eslint-disable-next-line no-unused-expressions
					collapsibleHeaderRef?.current?.querySelector("._pendo-badge input").setAttribute("aria-label", "Form elements Use Guide");
					collapsibleHeaderRef?.current?.querySelector("._pendo-badge input").setAttribute("aria-description", formSectionBadgeDescription);
				}
			}
		}, 200);
	}, [ collapsibleHeaderRef ]);

	return (
		<div className="ui styled fluid accordion">
			<div
				className={"title blue " + (collapsed ? "" : "active ") + styles.header}
				onClick={() => setCollapsed(!collapsed)}
				tabIndex={0}
				role="button"
				aria-expanded={!collapsed}
				ref={collapsibleHeaderRef}
			>
				<i className="dropdown icon"/>
				{title}
				{title === "Form Sections" && (
					<div className={styles.settings}>
						<SectionSettings sections={sections} onChangeMasterUpdate={onChangeMasterUpdate}/>
					</div>
				)}
			</div>
			{!collapsed && (<div className="active content">
				{children}
			</div>)}
		</div>
	);
}

export default CollapsibleSection;
